module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_title_5-f087d861ebf5a1b68b3750b4e16712cb.svg";